export default class ScrollArrows {
  constructor(node) {
    this.node = node

    this.arrowDown = this.node.querySelector('.arrow--down')
    this.arrowUp = this.node.querySelector('.arrow--up')

    this.scrollableDiv = document.querySelector('.section-bottom-scrollable')

    this.clickActionDown = this.clickActionDown.bind(this)
    this.clickActionUp = this.clickActionUp.bind(this)

    this.scrollAmount = 40

    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    this.arrowDown.addEventListener('click', this.clickActionDown)
    this.arrowUp.addEventListener('click', this.clickActionUp)
  }

  clickActionDown(e) {
    e.preventDefault()
    this.scrollableDiv.scrollBy(0, this.scrollAmount)
  }

  clickActionUp(e) {
    e.preventDefault()
    this.scrollableDiv.scrollBy(0, -this.scrollAmount)
  }

  static init() {
    ScrollArrows.item = new ScrollArrows(
      document.querySelector('.scroll-arrows')
    )
  }
}
